module.exports = __webpack_public_path__ + "img/user-active.5c6fb297.svg";